import { enumToOptions } from '@libs/types/src/common/enum/util';

export enum WaitingListRemovalReasonEnum {
    PROVIDED_DUE_TO_NEWLY_AVAILABLE_CAPACITY = 'providedDueToNewlyAvailableCapacity',
    PROVIDED_BY_ANOTHER_PROVIDER = 'providedByAnotherProvider',
    APPLICANT_REQUESTED_REMOVAL = 'applicantRequestedRemoval',
    APPLICANT_HAS_DIED = 'applicantHasDied',
    APPLICANT_WAS_REMOVED_AUTOMATICALLY_BY_INTERNAL_RULES = 'applicantWasRemovedAutomaticallyByInternalRules',
    ANOTHER_REASON = 'anotherReason'
}

export const waitingListRemovalReasonOptions = enumToOptions(WaitingListRemovalReasonEnum, 'waitingList.enums.removalReason.');
